
class DynamicYieldAPIClass {
	cache = {};
	chains = {};

	preload( selectors, options ) {
		const promise = this.getChoices( selectors, options );

		// Add Promise to Cache, if cacheable.
		const group = options.group;
		if ( group ) {
			[].concat( selectors ).forEach( ( selector ) => {
				this.cache[ group ] ??= {};
				this.cache[ group ][ selector ] = promise;
			} );
		}

		return promise;
	}

	getChoices( selector, options = {} ) {
		const { group, realtimeRules, distinct, ...restOptions } = options;
		if ( 'string' === typeof selector ) {
			if ( realtimeRules ) {
				selector = {
					names: [ selector ],
					args: {
						[ selector ]: {
							realtimeRules,
						},
					},
				};
			} else if ( group ) {
				const groupCache = this.cache[ group ] || {};
				const cached = groupCache[ selector ] ?? null;
				if ( cached ) {
					return cached;
				}
			}
		}

		const DY = window.DY || {};
		const context = {
			page: DY.recommendationContext || null,
			...options?.context ?? {},
		};

		return this.choose( {
			...restOptions,
			context,
			selector,
			distinct: String( distinct ) !== 'false',
		} );
	}

	async choose( body ) {
		const url = this.getEndpoint( 'choose' );
		const promise = fetch( url, {
			'method': 'POST',
			'headers': {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			'body': JSON.stringify( body ),
		} );

		return await promise.then( async( res ) => {
			if ( res.ok ) {
				return await res.json();
			}

			return await Promise.reject( await res.json() );
		} );
	}

	getEndpoint( fnc ) {
		const base = window.KOE_SHOP_ENDPOINTS?.dynamicYieldApi || '/index.php?cl=dynamic_yield_api';
		const url = new URL( base, window.location.origin );

		url.searchParams.set( 'fnc', fnc );
		url.searchParams.set( 'skipSession', '1' );

		return url.toString();
	}

	async request( fnc, body ) {
		const promise = fetch( this.getEndpoint( fnc ), {
			'method': 'POST',
			'headers': {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			'body': JSON.stringify( body ),
		} );

		return await promise.then( async( res ) => {
			if ( res.status === 204 ) {
				return {};
			}

			const data = await res.json().catch( () => ( {} ) );
			if ( res.ok ) {
				return data;
			}

			return await Promise.reject( data );
		} );
	}

	async suggest( query, options = {} ) {
		return await this.request( 'suggest', {
			query,
			maxResults: options.maxResults || 8,
			context: this.getRecommendationContext(),
		} );
	}

	async searchSuggestProducts( query, options = {} ) {
		return await this.request( 'searchSuggestProducts', {
			query,
			searchSelector: options.searchSelector || 'Semantic Search',
			searchResultCount: options.searchResultCount || 15,
			context: this.getRecommendationContext(),
		} );
	}

	getRecommendationContext() {
		return window.DY?.recommendationContext || null;
	}
}

export default new DynamicYieldAPIClass();
